var menuSticky = (function(){
	var offSet = $('.bar-navigation').offset();
	var jaFixou = false;

	function sticky(){
		if($(window).scrollTop() >= offSet.top){
			$('.bar-navigation').addClass('fixa');

			if(jaFixou == false){
				$('.bar-navigation').after('<div id="nav-placeholder" style="height: '+$('.bar-navigation').outerHeight()+'px"></div>');

				jaFixou = true;
			}
		}else{
			$('.bar-navigation').removeClass('fixa');
			$('#nav-placeholder').remove();

			jaFixou = false;
		}
	}

	sticky();

	$(window).scroll(function(){
		sticky();
	});

})();